var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRightAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 244,
    viewBox: "0 0 166 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.714,
    cy: 129.714,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 129.714,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 129.714,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 129.714,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 129.714,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.714,
    cy: 157.142,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 157.142,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 157.142,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 157.142,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 157.142,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.714,
    cy: 182.857,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 182.857,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 182.857,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 182.857,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 182.857,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.714,
    cy: 210.285,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 210.285,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.571,
    cy: 210.285,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 210.285,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 155.714,
    cy: 210.285,
    r: 1.71429,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.5 244C191.707 244 247 189.379 247 122C247 54.6213 191.707 0 123.5 0C55.2928 0 0 54.6213 0 122C0 189.379 55.2928 244 123.5 244ZM123.5 183C157.604 183 185.25 155.689 185.25 122C185.25 88.3106 157.604 61 123.5 61C89.3964 61 61.75 88.3106 61.75 122C61.75 155.689 89.3964 183 123.5 183Z",
    fill: "#DDE6FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.5 232C187.632 232 238 181.632 238 119.5C238 57.368 187.632 7 125.5 7C63.368 7 13 57.368 13 119.5C13 181.632 63.368 232 125.5 232ZM125.5 175.75C156.566 175.75 181.75 150.566 181.75 119.5C181.75 88.434 156.566 63.25 125.5 63.25C94.434 63.25 69.25 88.434 69.25 119.5C69.25 150.566 94.434 175.75 125.5 175.75Z",
    fill: "#A8BFFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightAgenda);
export default __webpack_public_path__ + "static/media/top_right_agenda.24e945d1a40b49dc48c1ae9a1363c18e.svg";
export { ForwardRef as ReactComponent };